import React from "react"
import type { TypeI18n, TypePlanStatePoiStatus } from "../../../types"
import { connect } from "react-redux"
import actions from "../../../store/actions"
import logger from "../../../utils/logger"

import config from "../../../config"
import OccupancyRow from "./OccupancyRow"
import type { RestaurantAttendance } from "../../../store/plans/PlansReducer"

type TypeProps = {
  +i18n: TypeI18n,
  +pois: TypePoi[],
  +fetchPoisStatuses: () => Promise<any>,
  +fetchRestaurantAttendance: () => Promise<any>,
  +poisStatuses: TypePlanStatePoiStatus[],
  +restaurantAttendance: RestaurantAttendance
}

type TypeState = {
  refreshing: boolean
}

const floors = [
  {
    label: "8",
    value: "N08"
  },
  {
    label: "7",
    value: "N07"
  },
  {
    label: "6",
    value: "N06"
  },
  {
    label: "5",
    value: "N05"
  },
  {
    label: "4",
    value: "N04"
  },
  {
    label: "3",
    value: "N03"
  },
  {
    label: "2",
    value: "N02"
  },
  {
    label: "1",
    value: "N01"
  },
  {
    label: "RDC",
    value: "N00"
  }
]

const REFRESH_TIMER: string = 120000

class OccupancyOverview extends React.PureComponent<TypeProps, TypeState> {
  state = {
    refreshing: false
  }

  fetchData() {
    this.props.fetchPoisStatuses().catch(err => logger.error(err))
    this.props.fetchRestaurantAttendance().catch(err => logger.error(err))
  }

  componentDidMount() {
    this.fetchData()
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.fetchData()
      }, REFRESH_TIMER)
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  render() {
    const { i18n, poisStatuses } = this.props

    return (
      <div style={styles.occupancyContainer}>
        <div style={styles.header}>
          <p style={styles.textTitle}>{i18n.t("occupancy.title")}</p>
          <div style={styles.categoriesWrap}>
            <div style={styles.categoryBox}>
              <p style={styles.text}>{i18n.t("occupancy.desks")}</p>
            </div>
            <div style={styles.categoryEtage}>
              <p style={styles.text}>{i18n.t("occupancy.floors")}</p>
            </div>
            <div style={styles.categoryBox}>
              <p style={styles.text}>{i18n.t("occupancy.meetingRooms")}</p>
            </div>
          </div>
        </div>

        <div style={styles.building}>
          {floors.map((floor, index) => (
            <OccupancyRow
              status={poisStatuses.filter(
                poiStatus => poiStatus.floorId === floor.value
              )}
              floor={floor}
              i18n={i18n}
            />
          ))}
        </div>
      </div>
    )
  }
}

const OccupancyOverviewConnected = connect(
  s => ({
    i18n: s.i18n,
    poisStatuses: s.plans.status
  }),
  d => ({
    fetchPoisStatuses: () => d(actions.plans.fetchStatuses()),
    fetchRestaurantAttendance: () =>
      d(actions.plans.fetchRestaurantAttendance())
  })
)(OccupancyOverview)
export default OccupancyOverviewConnected

const styles = {
  occupancyContainer: {
    position: "absolute",
    paddingLeft: 20,
    paddingRight: 20,
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    minHeight: 1000,
    minWidth: 500,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "white"
  },
  header: {
    marginBottom: 15
  },
  categoriesWrap: {
    flexDirection: "row",
    display: "flex"
  },
  building: {
    flexDirection: "column",
    display: "flex",
    flex: 1
  },
  categoryBox: {
    display: "flex",
    justifyContent: "center",
    width: "33.3%",
    alignItems: "center",
    backgroundColor: "#f8f9fa",
    paddingTop: 20,
    paddingBottom: 20,
    marginLeft: 10,
    marginRight: 10
  },
  categoryEtage: {
    display: "flex",
    width: "35%",
    marginLeft: 15,
    marginRight: 15,
    alignItems: "center",
    justifyContent: "center"
  },
  text: {
    color: config.theme.colors.main,
    fontSize: 25,
    textAlign: "center",
    margin: 0
  },
  textTitle: {
    fontSize: 30,
    textAlign: "center"
  }
}



// WEBPACK FOOTER //
// ./src/ui/screens/occupancy/OccupancyOverview.js